import React from 'react';
import Revista from '../revista/Revista';

const Layout = () => {  

    return (
        <div className="container">
            <div className="container-fluid page-body-wrapper">
                <div className="main-panel">
                    <div className="content-wrapper">
                        <Revista/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout 